import React, { useState, useEffect } from 'react';
import {Link, Navigate, useParams} from 'react-router-dom';
import Navbar from '../Components/Navbar/navbar.jsx';
import './editarcliente.css';
import firebase, { storage } from '../Config/firebase';
import { collection, doc, getDoc, getFirestore, setDoc, query, orderBy, getDocs, deleteDoc } from 'firebase/firestore';
import SweetAlert from 'react-bootstrap-sweetalert';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';


function EditarCliente(props){
    let cpfaux = '';
    const [clicart,setClicart] = useState([]);
    const [ident,setIdent] = useState('');
    const [nome,setNome] = useState('');
    const [email,setEmail] = useState('');
    const [fone,setFone] = useState('');
    const [siape,setSiape] = useState('');
    const [cpf,setCpf] = useState('');
    const [endereco,setEndereco] = useState('');
    const [bairro,setBairro] = useState('');
    const [cidade,setCidade] = useState('');
    const [estado,setEstado] = useState('');
    const [cep,setCep] = useState('');
    const [lotacao,setLotacao] = useState('');
    const [processo,setProcesso] = useState('');
    const [valor,setValor] = useState('');
    const [obs1,setObs1] = useState('');
    const [urlcart,setUrlcart] = useState('');
    const [lixo,setLixo] = useState('');
    const [cartn,setCartn] = useState('');
    const [carts,setCarts] = useState('');
    const [cartc,setCartc] = useState('');
    const [cartu,setCartu] = useState('');

    const [confirmacao,setConfirmacao] = useState(false);
    const [confirmacaoId,setConfirmacaoId] = useState('');

    const [acoes,setAcoes] = useState([]);
    const [busca,setBusca] = useState([]);
    const [excluido,setExcluido] = useState([]);
    
    const [mensagem,setMensagem] = useState('');
    const [sucesso,setSucesso] = useState('N');
    const [txteproc,setTxteproc] = useState('https://eproc.jfrj.jus.br/eproc/externo_controlador.php?acao=processo_seleciona_publica&acao_origem=processo_consulta_publica&acao_retorno=processo_consulta_publica&num_processo=')
    const params = useParams();
    const db = getFirestore();

    const [imgURL, setImgURL] = useState('');
    const [progress, setProgress] = useState(0);

    const handleUpload = (event) => {
      event.preventDefault();
      const file = event.target[0]?.files[0];
      const teste = 'images/' + file.name;
      console.log('nome: ', teste);
      if(!file) return;
      const storageRef = ref(storage, teste);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        snapshot => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setProgress(progress);
        },
        error => {
          alert(error.message)
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then (url => {
            setImgURL(url);
            console.log('URL: ', url);
          })
        }
      )
    }

 
  function CartDig() {
     console.log('Nome do url:', urlcart);
     const pathReference = ref(storage, urlcart);
     getDownloadURL(pathReference).then (url => {
      setImgURL(url);
     })
  }

  function deleteProce(id){
    const db = getFirestore();
    deleteDoc(doc(db,'acoes',id)).then(()=>{
       setExcluido(id);
       setConfirmacao(false);
    })
   }

   function confirmDeleteProce(id){
    setConfirmacaoId(id);
    setConfirmacao(true);
   }

     useEffect(() =>{
          const fetchData = async () => {

          const docRef = doc(db, 'clientes', params.id);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
             setNome(docSnap.data().nome);
             setEmail(docSnap.data().email);
             setFone(docSnap.data().fone);
             setSiape(docSnap.data().siape);
             setCpf(docSnap.data().cpf);
             cpfaux = docSnap.data().cpf;
             setProcesso(docSnap.data().processo);
             setValor(docSnap.data().valor);
             setEndereco(docSnap.data().endereco);
             setBairro(docSnap.data().bairro);
             setCidade(docSnap.data().cidade);
             setEstado(docSnap.data().estado);
             setCep(docSnap.data().cep);
             setLotacao(docSnap.data().lotacao);
             setObs1(docSnap.data().obs1);
             setLixo(docSnap.data().lixo);
             setCartn(docSnap.data().nome);
             setUrlcart(docSnap.data().urlcart);
             setCarts(docSnap.data().siape);
             setCartc(docSnap.data().cpf);
             setIdent(docSnap.id);
             setClicart([...clicart, docSnap.data().cpf,docSnap.data().nome]);

//             setTxteproc('https://eproc.jfrj.jus.br/eproc/externo_controlador.php?acao=processo_seleciona_publica&acao_origem=processo_consulta_publica&acao_retorno=processo_consulta_publica&num_processo=' + docSnap.data().processo)
             console.log("Dado do Documento:", cpfaux);
          } else {
            // docSnap.data() will be undefined in this case
            console.log("Não encontrado!");
          }
        }
        fetchData();
     }, [])

     useEffect(() => {
             let listapro = [];
             const fetchData = async () => {
               const db = getFirestore();
               const clientesRef = collection(db, 'acoes');
               const q = query(clientesRef, orderBy('cpf'));
               const snapshot = await getDocs(q);
               
               snapshot.forEach((doc) => {
                 if (doc.data().cpf.indexOf(busca) >= 0){
                  if (doc.data().cpf === cpfaux){
                  listapro.push({
                   id: doc.id,
                   cpf: doc.data().cpf,
                   processo: doc.data().processo,
                   acao: doc.data().acao,
                   valor: doc.data().valor,
                   situacao: doc.data().situacao,
                   data: doc.data().data
                  })
                }
                 }
               });
               setAcoes(listapro);
             };
           
             fetchData();
         }, [busca,excluido]);

     function AlterarCliente(){
        if (nome.length === 0){
            setMensagem('Informe o nome');
        }
        else{
            const docRef = setDoc(doc(db, 'clientes', params.id),{
              nome: nome,
              processo: processo,
              valor: valor,
              siape: siape,
              cpf: cpf,
              endereco: endereco,
              bairro: bairro,
              cidade: cidade,
              estado: estado,
              cep: cep,
              fone: fone,
              email: email,
              lotacao: lotacao,
              urlcart: urlcart,
              lixo: lixo,
              obs1: obs1
            })
            .then((docRef) => {
              setMensagem('');
              setSucesso('S');
            })
            .catch((error) => {
              setMensagem(error);
              setSucesso('N');
            })
      }
      }

    function OpeninNewTab(processo){
      let txt2 = 'https://eproc.jfrj.jus.br/eproc/externo_controlador.php?acao=processo_seleciona_publica&acao_origem=processo_consulta_publica&acao_retorno=processo_consulta_publica&num_processo=' + processo;
      console.log("Nome no processo:", processo);
      setTxteproc('https://eproc.jfrj.jus.br/eproc/externo_controlador.php?acao=processo_seleciona_publica&acao_origem=processo_consulta_publica&acao_retorno=processo_consulta_publica&num_processo=' + processo);
      console.log("texto eproc:",txt2);
      const win = window.open(txt2, '_blank');
    }

    return <div>
        <Navbar/>
        <div className="container-fluid titulo">
          <div className="offset-lg-1 col-lg-10">  
            <h1>Cadastro do Sindicalizado</h1>

            

            <form>
              <button onClick={CartDig} type="button" className="btn btn-primary btn-fot1">Foto</button>
              
              <Link to={"/app/carteira/" + ident} className="btn btn-dark btn-lg btn-banner btn-cart" type="button"> Carteira Digital</Link>
              <label htmlFor="exampleInputEmail1" className="form-label ">Nome</label>
              <input onChange={(e) => setNome(e.target.value)} value={nome} type="text" className="form-control bg-dark-subtle w-50" id="exampleInputEmail1" aria-describedby="emailHelp"></input>

                <div className="tipo1">
                  <div className="tipo12">
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">Siape</label>
                    <input onChange={(e) => setSiape(e.target.value)} value={siape} type="text" className="form-control bg-secondary-subtle w-75" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  </div>
                  <div className="tipo12">
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">Cpf</label>
                    <input onChange={(e) => setCpf(e.target.value)} value={cpf} type="text" className="form-control bg-secondary-subtle w-75" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  </div>
                </div>

                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">Endereco</label>
                    <input onChange={(e) => setEndereco(e.target.value)} value={endereco} type="text" className="form-control bg-secondary-subtle w-75" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  <div className="tipo1">
                  <div className="tipo12">
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">Bairro</label>
                    <input onChange={(e) => setCidade(e.target.value)} value={cidade} type="text" className="form-control bg-secondary-subtle w-100" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  </div>
                  <div className="tipo12">
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">Cidade</label>
                    <input onChange={(e) => setBairro(e.target.value)} value={bairro} type="text" className="form-control bg-secondary-subtle w-100" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                    
                  </div>
                  <div className="tipo12">
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">Estado</label>
                    <input onChange={(e) => setEstado(e.target.value)} value={estado} type="text" className="form-control bg-secondary-subtle w-25" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  </div>
                  <div className="tipo12">
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">CEP</label>
                    <input onChange={(e) => setCep(e.target.value)} value={cep} type="text" className="form-control bg-secondary-subtle w-50" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  </div>
                  </div>
                  <div className="tipo1">
                  <div className="tipo12">
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">Fone</label>
                    <input onChange={(e) => setFone(e.target.value)} value={fone} type="text" className="form-control bg-secondary-subtle w-75" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  </div>
                  <div className="tipo12">
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">Email</label>
                    <input onChange={(e) => setEmail(e.target.value)} value={email} type="text" className="form-control bg-secondary-subtle w-100" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  </div>
                  </div>

                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">Lotação</label>
                    <input onChange={(e) => setLotacao(e.target.value)} value={lotacao} type="text" className="form-control bg-secondary-subtle w-50" id="exampleInputEmail1" aria-describedby="emailHelp"></input>

                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">URL Foto</label>
                    <input onChange={(e) => setUrlcart(e.target.value)} value={urlcart} type="text" className="form-control bg-secondary-subtle w-50" id="exampleInputEmail1" aria-describedby="emailHelp"></input>

                  <label htmlFor="exampleInputEmail1" className="form-label pt-3">Aviso</label>
                  <input onChange={(e) => setObs1(e.target.value)} value={obs1} type="text" className="form-control bg-secondary-subtle w-100" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  <br>
                  </br>
                  <form onSubmit={handleUpload}>
                    <input type="file" />
                    <button type="submit"> Enviar </button> 
                  </form>
                  <br />
                  {!imgURL && <progress value={progress} max="100" />}
                  {imgURL  && <img  src={imgURL} alt="Imagem" className='img-fot1'/>}
                  {urlcart  && <img  src={urlcart} alt="Imagem" />}

               
                <div className = "text-center">
                  <Link to="/app/home" className="btn btn-outline-primary btn-mos1">Descartar Alterações</Link>
                  <button onClick={AlterarCliente} type="button" className="btn btn-primary btn-mos2">Salvar</button>
                </div>
                {mensagem.length>0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
                {sucesso==='S' ? <Navigate to='/app/home' /> : null}
            </form>
            <table className="table table-hover table-bordered mt-3">
    <thead>
      <tr className="table-secondary">

        <th scope="col">Ação</th>
        <th scope="col">Processo</th>
        <th scope="col">Data</th>
        <th scope="col">Valor</th>
        <th scope="col">Situacao</th>
        <th scope="col" className='col-acao'></th>
      </tr>
    </thead>
    <tbody>

    {
        acoes.map(function(proce){
            return <tr  key={proce.id}>

            <td>{proce.acao}</td>
            <td>{proce.processo}</td>
            <td>{proce.data}</td>
            <td>{proce.valor}</td>
            <td>{proce.situacao}</td>
            <td>
               <Link to={'/app/editarprocesso/' + proce.id} ><i className="fa-solid fa-pen-to-square icone-acao"></i></Link>
               <Link to= '#' onClick={()=>OpeninNewTab(proce.processo)}><i className="fa-solid fa-duotone fa-light - fa-eye icone-acao"></i></Link>
               <Link to= '#' onClick={()=>confirmDeleteProce(proce.id)}><i className="fa-sharp fa-solid fa-trash icone-acao red"></i></Link>
            </td>
           
          </tr>    
        })
    }

      
    </tbody>
  </table>

           {
           confirmacao ? <SweetAlert
              warning
              showCancel
              showCloseButton
              confirmBtnText="Sim"
              confirmBtnBsStyle="danger"
              cancelBtnText="Não"
              cancelBtnBsStyle="light"
              title="Exclusão"
              onConfirm={() => deleteProce(confirmacaoId)}
              onCancel={() => setConfirmacao(false)}
                reverseButtons={true}
            >
              Deseja exluir o processo selecionado?
          </SweetAlert> :null
          }
          </div>
        </div>  
    </div>
  }
  export default EditarCliente;